import {  
  Grid,
  Box,
  Button,
  TablePagination,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Card,
  CardContent,
  Alert,
  Skeleton
  } from '@material-ui/core';

  export const RackDetails = (props) => {


   const formatnumber = (value) => {
    return value.toFixed(2)
  };

    return (
      <>
        
        <Table size="small">
        <TableHead >
                    <TableRow>
                      <TableCell>
                       Name
                        
                      </TableCell>
                      <TableCell>
                        Leistung (kW)
                       
                      </TableCell>
                      <TableCell>
                      Täglicher Verbrauch (kWh)
                       
                      </TableCell>
                    </TableRow>
                  </TableHead>
        <TableBody>
        {props.circuitConsumptions.map((item, index) => (
            <TableRow key={index} >
             <TableCell>  
            {item.circuitName}
            </TableCell> 
            <TableCell>  
            {formatnumber(item.kWPower)} kW
            </TableCell> 
            <TableCell>  
            {formatnumber(item.kWhDaily)} kWh
            </TableCell> 
        </TableRow>
        ))}
        </TableBody>
        </Table>

        
      </>
    )
  }
